
export const FETCH_BENCHMARK_CALCULATION_PARAMETER_REQUEST = "FETCH_BENCHMARK_CALCULATION_PARAMETER_REQUEST";
export const FETCH_BENCHMARK_CALCULATION_PARAMETER_RESPONSE = "FETCH_BENCHMARK_CALCULATION_PARAMETER_RESPONSE";
export const FETCH_CALCULATE_BENCHMARK_REQUEST = "FETCH_CALCULATE_BENCHMARK_REQUEST";
export const FETCH_CALCULATE_BENCHMARK_RESPONSE = "FETCH_CALCULATE_BENCHMARK_RESPONSE";

export const fetchBenchmarkCalculationParameterRequest = (data) => {
    return {
        type: FETCH_BENCHMARK_CALCULATION_PARAMETER_REQUEST,
        data
    }
}

export const fetchBenchmarkCalculationParameterResponse = (data) => {
    return {
        type: FETCH_BENCHMARK_CALCULATION_PARAMETER_RESPONSE,
        data
    }
}

export const fetchCalculateBenchmarkRequest = (data) => {
    return {
        type: FETCH_CALCULATE_BENCHMARK_REQUEST,
        data
    }
}

export const fetchCalculateBenchmarkResponse = (data) => {
    return {
        type: FETCH_CALCULATE_BENCHMARK_RESPONSE,
        data
    }
}